import { graphql } from "@/gql";

export const updatePromotionChannelMutation = graphql(`
  mutation UpdatePromotionChannel(
    $id: ID!
    $input: UpdatePromotionChannelInput!
  ) {
    updatePromotionChannel(id: $id, input: $input) {
      id
      status
      budget_amount
    }
  }
`);

export const syncPromotionChannelMutation = graphql(`
  mutation SyncPromotionChannel($id: ID!) {
    syncPromotionChannel(id: $id) {
      id
      status
      impressions
      clicks
      conversions
      spend_amount
      last_synced_at
    }
  }
`);
